<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("SALES_PAYMENTS.EDIT_SALES_PAYMENT") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <salesPayment-form
              :loading="loading"
              :salesPaymentData="salesPayment"
              :formErrors="formErrors"
              @salesPaymentSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import SalesPaymentForm from "./partials/SalesPaymentForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultSalesPayment from "./defaultSalesPayment";

export default {
  layout: "DashboardLayout",

  components: { SalesPaymentForm },

  mixins: [alertLeave],

  data() {
    return {
      salesPayment: cloneDeep(defaultSalesPayment),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("salesPayments/get", id);
        this.salesPayment = this.$store.getters["salesPayments/salesPayment"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List SalesPayments" });
    },

    viewSalesPayment() {
      this.alertLeave = false;
      this.$router.push({
        name: "View SalesPayment",
        params: { id: this.salesPayment.id },
      });
    },

    async handleSubmit(salesPayment) {
      this.loading = true;

      const salesPaymentData = cloneDeep(salesPayment);
      if (!salesPaymentData.organization.id) {
        delete salesPaymentData.organization;
      }
      if (!salesPaymentData.reseller.id) {
        delete salesPaymentData.reseller;
      }

      try {
        await this.$store.dispatch("salesPayments/update", salesPaymentData);
        this.$notify({
          type: "success",
          message: this.$t("SALES_PAYMENTS.SALES_PAYMENTS_UPDATED"),
        });
        this.viewSalesPayment();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
